<template>
  <div class="page-show">
    <TableItem v-model="comment" />
  </div>
</template>

<script>
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import TableItem from './table-item.vue';

@Component({
  components: {
    TableItem
  }
})
export default class ShowPage extends Vue {
  @Prop({ type: Object, default: () => ({}) }) value;

  comment = {};

  @Watch('value', { immediate: true })
  onValueChanage(val = {}) {
    this.comment = { ...val };
    console.log(this.comment);
  }
}
</script>

<style scoped>
  .page-show {
    height: 100%;
    overflow: auto;
    padding: 15px;
  }
</style>
